import { useState } from "react"

import { SENDER_NAME_MAX_LENGTH } from "@productlane/api/src/lib/constants"
import { Input } from "@productlane/ui"

import { useAutosaveText } from "@/lib/use-autosave-text"

export const SENDER_NAME_DESCRIPTION =
	"Replies from this address show one team name."

export function SenderNameInput({
	senderName,
	workspaceName,
	onSave,
}: {
	senderName: string | null
	workspaceName: string
	onSave: (senderName: string | null) => void | Promise<void>
}) {
	const [value, setValue] = useState(senderName ?? "")
	const [isEdited, setIsEdited] = useState(false)

	const flush = useAutosaveText({
		value,
		persistedValue: senderName ?? "",
		onSave: (next) => onSave(next.trim() || null),
		enabled: isEdited,
	})

	return (
		<Input
			name="senderName"
			aria-label="Sender name"
			className="w-60 flex-none"
			value={value}
			maxLength={SENDER_NAME_MAX_LENGTH}
			placeholder={`Your name (${workspaceName})`}
			onChange={(e) => {
				setValue(e.target.value)
				setIsEdited(true)
			}}
			onBlur={() => flush()}
		/>
	)
}
